// Dominio público CANÓNICO de la app (alpeloelite.com desde 2026-07).
//
// Para TODO enlace/QR que sale de la app hacia fuera (reserva /book, registro
// /join, referidos, códigos regalo, enlaces de partner): antes se usaba
// window.location.origin, así que un barbero con la PWA instalada desde
// pro-barber.web.app repartía QRs y enlaces del dominio viejo. Con esta
// constante, todo lo compartible lleva SIEMPRE el dominio de marca,
// independientemente de desde dónde navegue quien lo genera. El dominio viejo
// sigue sirviendo la app (los QR ya impresos no se rompen).
//
// Módulo minúsculo y SIN dependencias a propósito: lo importan páginas
// públicas sensibles al peso (GuestBooking, _publicSeo) y no debe arrastrar
// nada al bundle (mismo patrón que src/fnBase.ts).
export const PUBLIC_ORIGIN = 'https://alpeloelite.com';
